
export default {
  name: 'icon-analytics-airplane',
};
